import type { Destination } from '@sentinel/shared';
import { goToHost, hostRole } from './app-hosts';

/** The app a destination opens in: the console on `console.`, organizations and support
 *  windows on `control.` (ADR 0013). */
export function hostOfDestination(destination: Destination): 'console' | 'control' {
  return destination.kind === 'console' ? 'console' : 'control';
}

/** Whether entering the destination means leaving this app for another host. */
export function leavesHost(destination: Destination): boolean {
  const role = hostRole();
  if (role === 'single') return false;
  return role === 'accounts' || hostOfDestination(destination) !== role;
}

export function openOnItsHost(destination: Destination): void {
  goToHost(hostOfDestination(destination), {
    ...(destination.kind === 'organization' ? { organizationId: destination.organizationId } : {}),
    ...(destination.kind === 'support' ? { grantId: destination.grantId } : {}),
  });
}
